import { FC } from "react";

import { Icon, IconProps } from "@chakra-ui/icons";

const CustomIcon: FC<Omit<IconProps, "css">> = ({ children, ...props }) => (
  <Icon x="0px" y="0px" width="24px"viewBox="0 0 24 24" fill="none" {...props}>
    <path d="m12 2c-2.65216 0-5.1957 1.05357-7.07107 2.92893-1.87536 1.87537-2.92893 4.41891-2.92893 7.07107 0 2.6522 1.05357 5.1957 2.92893 7.0711 1.87537 1.8753 4.41891 2.9289 7.07107 2.9289 2.6522 0 5.1957-1.0536 7.0711-2.9289 1.8753-1.8754 2.9289-4.4189 2.9289-7.0711 0-2.65216-1.0536-5.1957-2.9289-7.07107-1.8754-1.87536-4.4189-2.92893-7.0711-2.92893z" fill="#fff"/><path d="m13.3537 14.6506h2.5879l.4063-2.629h-2.9947v-1.4368c0-1.09212.3568-2.06054 1.3784-2.06054h1.6416v-2.29421c-.2884-.03895-.8984-.12422-2.0511-.12422-2.4068 0-3.8179 1.27106-3.8179 4.16687v1.7489h-2.47417v2.629h2.47417v7.2258c.49.0736.9864.1236 1.4958.1236.4606 0 .91-.0421 1.3537-.1021z" fill="#1877f2"/>
  </Icon>
);

export default CustomIcon;
